// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3CKEV","select":"Header_select__3bFxY","clinic":"Header_clinic__1Xd2z"};